import React,{Component} from 'react';
import './progress-bar.scss';

export default class ProgressBar extends Component{
  constructor(props) {
    super(props);
  }

  render(){
    let transform = {
      transform: 'scaleX('+(this.props.progress/100)+')'
    }
    return(
      <div className="progress-bar">
        <div className="progress-text">
          {this.props.progress}%
        </div>
        <div className="progress">
          <div className="progress-outside">
            <div className="progress-inner" style={transform}>
            </div>
          </div>
        </div>
        <div className="loading">
          <span className="char1">L</span>
          <span className="char2">O</span>
          <span className="char3">A</span>
          <span className="char4">D</span>
          <span className="char5">I</span>
          <span className="char6">N</span>
          <span className="char7">G</span>
          <span className="char8">.</span>
          <span className="char9">.</span>
          <span className="char10">.</span>
        </div>

      </div>

    );
  }

}
